import Cookies from 'js-cookie';
import * as actionType from './actionsTypes';
import { getUserTimezone, resHandle, userTimezone } from '../helper';
import {
    login,
    signup,
    fastSignup,
    verifyemailotp,
    logout,
    forgotPassword,
    resetPassword,
    resendOtp,
    verifyFastOtp,
    switchRole,
} from '../services/authService';
import { updateCampCodeService } from '../services/superDirectorService';
import ApiInstance from '../services/intercepter';

//import { addToCart } from '../services/programService';


let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? {loggedIn: true, userProfile: user } : {};


/************************************************************************************/
// User Reducer
/************************************************************************************/


const userReducer = (state = initialState, action) => {

    switch (action.type) {


        case actionType.LOGIN_REQIEST:
        case actionType.SIGNUP_REQIEST:
            return {
                ...state,
                loading: true,
            };


        case actionType.LOGIN_SUCCESS:
        case actionType.SIGNUP_SUCCESS:
            return {
                ...state,
                loggedIn: true,
                loading: false,
                userProfile: action.payload,
            };

        case actionType.UPDATE_USER_PROFILE: 
       
        return {
                ...state,
                userProfile: action.payload,
            };

        case actionType.CHECK_IS_COUNSELOR: 
        return {
                ...state,
                userProfile: action.payload,
            };


        case actionType.LOGIN_FAILURE:
        case actionType.SIGNUP_FAILURE:
            return {
                loading: false,
                error: action.payload
            };


        case actionType.CLEAR_ERROR_MSG:
            return {
                ...state,
                error: ''
            };

        case actionType.CLEAR_LOADER:
            return {
                ...state,
                loading: false
            };



        case actionType.LOGOUT:
            return {};

            
        default:
            return state
    }
}




/************************************************************************************/
// All User Actions
/************************************************************************************/




export const clearErrorMsgAction = () => (dispatch => dispatch({ type: actionType.CLEAR_ERROR_MSG }));

export const checkIsCounselorAction = payload => (dispatch => dispatch({ type: actionType.CHECK_IS_COUNSELOR, payload }));





export const signupAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        let user = await signup(params);
        let { status, data } = resHandle(user);
        if(status){

            localStorage.setItem('userId', data.userId);

            dispatch({ type: actionType.SIGNUP_SUCCESS, payload: data });
            dispatch({ type: actionType.AUTH_MODAL, payload: 0 });
            dispatch({ type: actionType.IS_OTP_MODAL });
        }else{
            dispatch({ type: actionType.SIGNUP_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.SIGNUP_FAILURE, payload: error });
    }
}


export const fastSignupAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        let user = await fastSignup(params);
        let { status, data } = resHandle(user);
        if(status){
            if( data.message === "Invalid number. Enter a 10-digit mobile number." ){
                dispatch({ type: actionType.SIGNUP_FAILURE, payload: data.message || "Signup failed" });
                return false;
            }
            localStorage.setItem('userId', data.userId);

            dispatch({ type: actionType.SIGNUP_SUCCESS, payload: data });
            dispatch({ type: actionType.AUTH_MODAL, payload: 0 });
            dispatch({ type: actionType.IS_OTP_MODAL });
            return true;
        }else{
            dispatch({ type: actionType.SIGNUP_FAILURE, payload: data });
            return false;
        }
    } catch (error) {
        dispatch({ type: actionType.SIGNUP_FAILURE, payload: error });
        return false;
    }
}










export const verifyemailotpAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        let user = await verifyemailotp(params);
        let { status, data } = resHandle(user);
        if(status){
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('user', JSON.stringify(data.userProfile));
            localStorage.removeItem('cartitems');
            localStorage.removeItem('NonLoginUserID');
            localStorage.removeItem('NonLoginaccessToken');

            dispatch({ type: actionType.LOGIN_SUCCESS, payload: data.userProfile });
            dispatch({ type: actionType.IS_OTP_MODAL });

            Cookies.set('accessToken2', data.accessToken);
            Cookies.set('user2', JSON.stringify(data.userProfile));
            window.location.reload();
        }else{
            dispatch({ type: actionType.SIGNUP_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.SIGNUP_FAILURE, payload: error });
    }
}


export const verifyFastEmailotpAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        const {userId, otp} = params
        let user = await verifyFastOtp({userId, otp});
        let { status, data } = resHandle(user);
        if(status){
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('user', JSON.stringify(data.userProfile));
            params?.isAdmin==='1'?
            localStorage.setItem('isAdminLogin', params?.isAdmin) :
            localStorage.removeItem('isAdminLogin', params?.isAdmin);
            localStorage.removeItem('cartitems');
            localStorage.removeItem('NonLoginUserID');
            localStorage.removeItem('NonLoginaccessToken');
            // Before LOGIN_SUCCESS: it re-runs Header effects that call the API while the
            // redirect below is still pending - see the same line in switchRoleAction.
            ApiInstance.defaults.headers.common['accessToken'] = data.accessToken;
            dispatch({ type: actionType.LOGIN_SUCCESS, payload: data.userProfile });
            dispatch({ type: actionType.AUTH_MODAL, payload: 0 });
            Cookies.set('accessToken2', data.accessToken);
            Cookies.set('user2', JSON.stringify(data.userProfile));
            if(data?.userProfile?.UserType === 4 || params?.isAdmin){
                window.location.href = params?.redirectTo || '/profile/information';
                return true;
            }else{
                window.location.reload();
            }
            return false;
        }else{
            dispatch({ type: actionType.SIGNUP_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.SIGNUP_FAILURE, payload: error });
    }
}


// Switches the authenticated caller into their linked Parent/Counselor
// account. This is a real identity switch (a different User _id, a fresh
// JWT scoped to it) - NOT modeled after selectCampAction/switchCampAction
// below, which only relabel the SAME token locally because a Super
// Director's token already carries Director-tier access server-side. A
// Parent's token has none of a Counselor's permissions and vice versa, so
// every piece of stored auth state has to be replaced with what the backend
// returns, not merged into the existing userProfile.
export const switchRoleAction = targetUserType => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        let res = await switchRole({ targetUserType });
        let { status, data } = resHandle(res);
        if (status) {
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('user', JSON.stringify(data.userProfile));
            Cookies.set('accessToken2', data.accessToken);
            Cookies.set('user2', JSON.stringify(data.userProfile));
            // Must happen before any further API call - ApiInstance's
            // accessToken default is otherwise only re-read from
            // localStorage on the next full module load (i.e. the reload
            // below), so without this every request between now and then
            // would still authenticate as the old account.
            ApiInstance.defaults.headers.common['accessToken'] = data.accessToken;
            dispatch({ type: actionType.LOGIN_SUCCESS, payload: data.userProfile });
            // Unlike login's UserType===4 special case (which defaults to
            // /profile/information - a landing choice shared with admin
            // impersonation, not an onboarding gate: there's no completeness
            // check anywhere that requires visiting it first), a role switch
            // always lands on / - App.js already renders the correct
            // UserType-appropriate view there for both Parent and Counselor.
            window.location.href = '/';
            return { success: true };
        } else {
            dispatch({ type: actionType.LOGIN_FAILURE, payload: data });
            return { success: false, error: data };
        }
    } catch (error) {
        dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
        return { success: false, error };
    }
}


export const logoutAction = () => async dispatch => {
        localStorage.clear();
        handleClearAllCookies();
        dispatch({ type: actionType.LOGOUT });
        window.location.href = '/';
}

const handleClearAllCookies = () => {
    Object.keys(Cookies.get()).forEach(cookieName => Cookies.remove(cookieName));
};


export const upadteUserProfileAction = payload => (dispatch => dispatch({ type: actionType.UPDATE_USER_PROFILE, payload}))


// Super Director (UserType 11) selects which camp to sign in as.
// Persists the choice server-side (so the backend knows which camp this
// super director is currently acting as) before locally impersonating a
// camp director (UserType 2) so the rest of the app (routing, services,
// header nav) behaves exactly as it does for a director, while keeping
// isSuperDirector/originalUserType so we can offer "Switch Camp".
// `superDirectorCampSelected` is our own gate flag, independent of whatever
// `campCode` the backend may already have on the raw account (some super
// director accounts still carry a stale campCode from before this feature).
// Returns { success, error } instead of throwing, so the camp picker UI can
// re-enable itself and show an error without a try/catch at the call site.
export const selectCampAction = camp => async (dispatch, getState) => {
    let updatedTimezone;
    try {
        const res = await updateCampCodeService({ campCode: camp.campCode });
        const { status, data } = resHandle(res);
        if (!status) {
            return { success: false, error: data };
        }
        // The backend now sets the super director's own account timezone to match
        // the selected camp (same field/mechanism as a real director's account) —
        // pick it up from whichever shape the response actually returns it in, so
        // the frontend doesn't keep showing the stale timezone from original login.
        // TODO: confirm the exact field path and drop the unused fallbacks once known.
        updatedTimezone = data?.timezone || data?.userProfile?.timezone || data?.result?.timezone;
    } catch (error) {
        return { success: false, error: 'Unable to sign in to this camp. Please try again.' };
    }

    const { userProfile } = getState().user;
    const updatedProfile = {
        ...userProfile,
        originalUserType: userProfile.originalUserType || userProfile.UserType,
        isSuperDirector: true,
        superDirectorCampSelected: true,
        UserType: 2,
        campCode: camp.campCode,
        campName: camp.campName,
        // The super director's own account may carry a stale/unrelated subAccountId
        // (or none) — pages like Payments (justifi access token, payouts) key off
        // userProfile.subAccountId, so it must be swapped for the selected camp's own
        // to show that camp's payment data instead of the super director's.
        subAccountId: camp.subAccountId,
        timezone: updatedTimezone || userProfile.timezone,
    };

    localStorage.setItem('user', JSON.stringify(updatedProfile));
    Cookies.set('user2', JSON.stringify(updatedProfile));
    dispatch({ type: actionType.UPDATE_USER_PROFILE, payload: updatedProfile });
    window.location.href = '/';
    return { success: true };
}

// Drops the currently selected camp so the super director lands back on the
// camp selection screen.
export const switchCampAction = () => (dispatch, getState) => {
    const { userProfile } = getState().user;
    const updatedProfile = {
        ...userProfile,
        UserType: userProfile.originalUserType || 11,
        superDirectorCampSelected: false,
        campCode: '',
        campName: '',
        subAccountId: '',
    };

    localStorage.setItem('user', JSON.stringify(updatedProfile));
    Cookies.set('user2', JSON.stringify(updatedProfile));
    dispatch({ type: actionType.UPDATE_USER_PROFILE, payload: updatedProfile });
    window.location.href = '/';
}











export const loginAction = params => async dispatch => {
    dispatch({ type: actionType.SIGNUP_REQIEST });
    try {
        let user = await login(params);
        let { status, data } = resHandle(user);
        if(status){
            if(data.statusCode === 12) {
                localStorage.setItem('userId', data.userId);
                dispatch({ type: actionType.IS_OTP_MODAL });
                dispatch({ type: actionType.CLEAR_LOADER });
            }else{
  
                localStorage.setItem('accessToken', data.accessToken);
                localStorage.setItem('user', JSON.stringify(data.userProfile));
                localStorage.removeItem('cartitems');
                localStorage.removeItem('NonLoginUserID');
                localStorage.removeItem('NonLoginaccessToken');
                if(data?.userProfile?.UserType === 4){
                    window.location.href = '/profile/information';
                }
                // else{
                //     window.location.href = '/';
                // }
                
                dispatch({ type: actionType.LOGIN_SUCCESS, payload: data.userProfile });
                dispatch({ type: actionType.AUTH_MODAL, payload: 0 });
            }

        }else{
            dispatch({ type: actionType.LOGIN_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
    }
}










export const forgotPasswordAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    dispatch({ type: actionType.TEMP_EMAIL, payload: params.email});
    try {
        let resData = await forgotPassword(params);
        let { status, data } = resHandle(resData);
        if(status){
            dispatch({ type: actionType.FORGOT_MODAL });
            dispatch({ type: actionType.SUCCESS_MODAL });
        }else{
            dispatch({ type: actionType.LOGIN_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
    }
}










export const resetPasswordAction = params => async dispatch => {
    dispatch({ type: actionType.LOGIN_REQIEST });
    try {
        let resData = await resetPassword(params);
        let { status, data } = resHandle(resData);
        if(status){
            dispatch({ type: actionType.RESET_PASSWORD_MODAL });
            dispatch({ type: actionType.PASSWORD_SUCCESS_MODAL });
            dispatch({ type: actionType.LOGIN_FAILURE, payload: '' });
            return status;
        }else{
            dispatch({ type: actionType.LOGIN_FAILURE, payload: data });
        }
    } catch (error) {
        dispatch({ type: actionType.LOGIN_FAILURE, payload: error });
    }
}










export const resendOtpAction = params => async dispatch => {
    dispatch({ type: actionType.RESEND_OTP_EMAIL_LOADER });
    try {
        let resData = await resendOtp(params);
        let { status, data } = resHandle(resData);
        if(status){
            dispatch({ type: actionType.RESEND_OTP_EMAIL_LOADER });
        }else{
            dispatch({ type: actionType.RESEND_OTP_EMAIL_LOADER });
        }
    } catch (error) {
        dispatch({ type: actionType.RESEND_OTP_EMAIL_LOADER });
    }
}










export default userReducer;